const pageNameKey = "dropAreaAddImage";

export const dropAreaAddImageEn = {
  [pageNameKey]: {
    attachmentsLabel: "Attachments",
    uploadOrDragAndDropText: "Upload or drag & drop",
  },
};

export const dropAreaAddImagePtBr = {
  [pageNameKey]: {
    attachmentsLabel: "Anexos",
    uploadOrDragAndDropText: "Envie ou arraste e solte",
  },
};

export const dropAreaAddImageEs = {
  [pageNameKey]: {
    attachmentsLabel: "Archivos adjuntos",
    uploadOrDragAndDropText: "Sube o arrastra y suelta",
  },
};

export const dropAreaAddImageDe = {
  [pageNameKey]: {
    attachmentsLabel: "Anhänge",
    uploadOrDragAndDropText: "Hochladen oder per Drag & Drop",
  },
};

export const dropAreaAddImageZhHans = {
  [pageNameKey]: {
    attachmentsLabel: "附件",
    uploadOrDragAndDropText: "上传或拖放",
  },
};

export const dropAreaAddImageIt = {
  [pageNameKey]: {
    attachmentsLabel: "Allegati",
    uploadOrDragAndDropText: "Carica o trascina e rilascia",
  },
};

export const dropAreaAddImageNl = {
  [pageNameKey]: {
    attachmentsLabel: "Bijlagen",
    uploadOrDragAndDropText: "Uploaden of slepen en neerzetten",
  },
};

export const dropAreaAddImageTr = {
  [pageNameKey]: {
    attachmentsLabel: "Ekler",
    uploadOrDragAndDropText: "Yükleyin veya sürükleyip bırakın",
  },
};
